import axios from 'axios'
import router from '../router/index'
import store from '../store/index'
import {Toast} from 'vant';

const service = axios.create({
  baseURL: '', // api的base_url
  timeout: 60000, // 请求超时时间
})

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if(store.state.authToken){
    config.headers['Authorization'] = store.state.authToken;    //登录token
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


// respone拦截器
service.interceptors.response.use(
  response => {
    console.log('接口：'+response.config.url, response.data);
    // 返回判断
    var rd = response.data;
    if(rd.status){
      //正常请求
      return rd;
    }else{
      //异常请求
      if(rd.msg === '会话已失效'){
        store.commit('logout');
        Toast('请登录后进行此操作');
        router.push({path:'/login'});
      }else{
        Toast(rd.msg || '网络请求错误')
      }
      return Promise.reject(rd)
    }
  },
  error => {
    Toast.clear();
    var errData = JSON.parse(JSON.stringify(error));
    if(errData.message === 'Request failed with status code 401'){
      Toast('请登录后进行此操作');
      router.push({path:'/login'});
    }else{
      Toast(errData.message);
    }
    // 其他状态
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js